// extracted by mini-css-extract-plugin
export var head = "moreStories-module--head--gwoRP";
export var title = "moreStories-module--title--3mUmL";
export var switcherHead = "moreStories-module--switcherHead--fKSTp";
export var switcherTitle = "moreStories-module--switcherTitle--1M8Cf";